import React, {useState , useEffect , useContext} from 'react'
import {  useNavigate, useSearchParams } from "react-router-dom"
import axios from "axios";
import {Helmet} from 'react-helmet'
import { login } from './../../Redux/features/authSlice'
import { useSelector, useDispatch } from 'react-redux'
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { Link } from 'react-router-dom';
import { Main , Input, Checkbox, Button } from '../../Components';
import { Card } from '../../Components/Card/Card';
import moment from 'moment'
import { ReactComponent as Logo } from './../../assets/logo/logo.svg'

import './registration.css'
import toast from 'react-hot-toast';
import { updateGeneralUI } from '../../Redux/features/uiReducer';
/*
 * 
 * @returns 
 */
export function Registration() {

	const regex_validator = {
		email : /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
		
	}	

    const [searchParams] = useSearchParams();
	
	
	const [formData, setFormData] = useState({
		email: "",
		password: "",
		terms: true,
		company_name : "",
		subdomain : ""
		 
	});
	const [formValidation, setFormValidation] = useState({
		email: '',
		password: '',
		terms: '',
		company_name : '',
		subdomain : '',
		fieldsAreEdited : false 
		 
	});
	const [isLoading, setIsLoading] = useState(false)
	const [sessionToken, setSessionToken] = useState(null)
	 

	const { email, password , terms , company_name , subdomain , fieldsAreEdited} = formData;

	const navigate = useNavigate();
	const dispatch = useDispatch();

	
	// Grab the data from redux 
	const { user } = useSelector((state) => state.auth);

	 

	useEffect(() => {
		async function fetchData() {

            const preRegistredEmail = searchParams.get('email')
            if(typeof preRegistredEmail !=='undefined' && preRegistredEmail !==''){
                setFormData( prevState => ({
                    ...prevState,
                    email : preRegistredEmail
                }))
            }
			// You can await here
			await verifySession()
			.then(token => {
				setSessionToken(token)
				setIsLoading(false)
				 
			})
			.catch(err => {
				setIsLoading(false)
			 
				//globalData.logout();// update user session global state 
			});
			// ...
		}
		fetchData();
	
	   
	}, [])


	useEffect(() => {
		if(sessionToken !== null && user ){
			 
			navigate(`/`);
		}
	}, [sessionToken])


    /**
     * 
     * @returns 
     */
     const  verifySession = () =>  {

        return new Promise(async (resolve, reject) => {
            
             
            if (user && user.token) {
                
                const { token } = user;
                // //console.log(token);
                // Verify token
                await axios
                    .post(`${process.env.REACT_APP_API_URL}/users/session/verify`, { 
                        token : token 
    
                    })
                    .then(res => res.data )
                    .then(res => {
    
                        const expiredTime = res.exp;
                        if(moment().diff(moment(expiredTime*1000) , 'minutes') < 0 ){
                            resolve(token)
                        }else{
    
                            reject({
                                error : 'expired_session'
                            })
                        }
                         
                     
                    })
                    .catch(err => {
                        reject({
                            error : err
                        });
                    })
            } else {
                reject({
                    error: "no_token"
                })
             
            }
        });

    }
	

	const onChange = (e) => {

		


		switch(e.target.name){
			case "email" : 
				setFormValidation((prevState) => ({
					...prevState,
					email : (e.target.value.match(regex_validator.email)===null) ? 'Invalid email' : ''
				}))
				
				break;
			case "company_name" : 
				setFormValidation((prevState) => ({
					...prevState,
					company_name: (e.target.value === '') ? 'Invalid organization name' : ''
				}))
				
				break;
			case "password" : 
				setFormValidation((prevState) => ({
					...prevState,
					password : (e.target.value.length < 4 ) ? 'Password too short, try a mix of characters and numbers' : '' 
				}))
				
				break;
			case "terms" : 
				setFormValidation((prevState) => ({
					...prevState,
					terms : (e.target.checked === false ) ? 'Please read and accept our Terms of Service to continue' : '' 
				}))
				
				break;
		}

		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: (e.target.type ==='checkbox') ? e.target.checked :  e.target.value,
			fieldsAreEdited : true
		}));
	};


    /**
     * 
     * @param {*} e 
     * @returns 
     */
	const onSubmit = async (e) => {
		e.preventDefault();
		 
        setIsLoading(true)

		let userData = {
			email,
			password,
			company_name
			  
		};
        const invitationId = searchParams.get('invitationid')
        
        if(typeof invitationId!=='undefined' && invitationId!==null && invitationId!=='' ) userData.inviteId = invitationId;

        let preFieldsValidation = {
            email : (formData.email.match(regex_validator.email)===null) ? 'Invalid email' : '',
			company_name: (formData.company_name === '') ? 'Invalid organization name' : '',
			password : (formData.password.length < 4 ) ? 'Password too short, try a mix of characters and numbers' : '',
			terms : (formData.terms === false ) ? 'Please read and accept our Terms of Service to continue' : '' 
        }
        
		if(preFieldsValidation.email !=='' || preFieldsValidation.company_name !=='' || preFieldsValidation.password !=='' || preFieldsValidation.terms !==''){
             
            
			toast.error("Please complete all required fields") 
            
            setFormValidation((prevState) => ({
                ...prevState,
                ...preFieldsValidation    
            }))
             
			setIsLoading(false)

			return 
		}




		await axios
			.post(`${process.env.REACT_APP_API_URL}/users/signup`, userData , {} )
			.then(res => res.data )
			.then(async response => {
				//console.log(response);

				if (typeof response?.token !== 'undefined' && response?.token !== null) {
					
					localStorage.setItem(process.env.REACT_APP_STORAGE_AUTH_USER, JSON.stringify(response))
					localStorage.setItem(process.env.REACT_APP_STORAGE_AUTH_ORG, JSON.stringify(response?.organizations?.find(x => x.is_default === true) ?? (response?.organizations?.length > 0 ?response?.organizations[0] : {})))
					 
					dispatch(login(response));
                    dispatch(updateGeneralUI({
                        show_sidebar : true
                    }))
					 
					setSessionToken(response?.token)

					setIsLoading(false)
					
				} else {
                    
                    toast.error("Something went wrong. Thank you try later.")   

					setIsLoading(false)
					
				}
			})
			.catch(error => {

				//console.log('error : ' , error);
				if (error.response) {
					
                    toast.error(error?.response?.data?.message) 
					 
					setIsLoading(false)
					
				} else {
					// Something happened in setting up the request that triggered an Error
					if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
						 
						toast.error("An error occurred while logging into your account, please try again later")  
                        
					}
                    setIsLoading(false)
				} 
			})

		 

		
	};

 

	return (
		<>
		<Helmet>
            <title>{`Create a new account - ${process.env.REACT_APP_APP_NAME}`}</title>
		</Helmet>
		<Main size={`full`} withNav={false}>
			<div className="layout-registration-form">
				<div className="logo-wrapper">
					<Logo />
				</div> 
				<Card shadow="md" target="registration">
					<form onSubmit={onSubmit}>
						<div className='title'>Get started for free </div>
						<Input 
							type="email"
							name="email"
							label="Email"
							placeholder="your@domain.com"
							required
							onChange={onChange}
							error={formValidation.email}
                            value={formData?.email}
							/>
						<Input 
							name="company_name" 
							label="Organization name" 
							placeholder="" 
							required 
							onChange={onChange} 
							
							error={formValidation.company_name}/>
						<Input 
							type="password" 
							name="password" 
							label="Password" 
							placeholder="Your password" 
							required  
							onChange={onChange}
							error={formValidation.password}/>
						<div>
							<Checkbox 
								name="terms"
								label="I accept the Terms of Service"
								onChange={onChange}
								checked={formData.terms}
								error={formValidation.terms}
							/>
						</div>
						<div className="field-group submit-fields-group fluid">
							<Button 
								onClick={onSubmit} 
								loading={isLoading}
								>Build your first status page</Button>
						</div>
					</form>
				</Card>
				<div className='under-form'>Already have an account? <Link to={`/login${searchParams.get('invitationid')!==null ? `?invitationid=${searchParams.get('invitationid')}` : ''}`}>Login</Link></div>
			</div>
		</Main>

		</>
	)
}

 